"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationStatus = exports.MemberSource = exports.InvitationType = void 0;
exports.InvitationType = {
    EMAIL_INVITED: "invited",
    URL_SELF_SIGN: "url_self_sign",
};
exports.MemberSource = {
    REGULAR: "regular",
    URL_SIGNUP: "url_signup",
};
var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["Active"] = "active";
    OrganizationStatus["Inactive"] = "inactive";
})(OrganizationStatus || (exports.OrganizationStatus = OrganizationStatus = {}));
